import React from 'react';
import Config from '../../config';

class DeliveryList extends React.Component {
  constructor() {
    super()
  }
  componentDidMount() {
    location.replace(
      `${Config.MAIN_URL}/activity2/delivery_list${window.location.search}`,
    )
  }
  render () {
    return null
  }
}

export default DeliveryList


// WEBPACK FOOTER //
// ./src/pages/BoughtPage/DeliveryList.js